export default defineAppConfig({
    title: 'AI IQ',

  })
  